export enum OnboardingFormType {
  Application,
  Library,
}
